// extracted by mini-css-extract-plugin
export default {"root":"SelectBranchInput_root__sB8nf","select":"SelectBranchInput_select__jxYsV","addButton":"SelectBranchInput_addButton__wKV1u"};